import React from 'react';
import { FIELD, FIELD_LABEL, ForgotFormData, ForgotFormProps } from './interface';
import { schemaForForgotPassword } from './validationSchema';
import { FormProvider, UseFormReturn, useForm, FormState } from 'react-hook-form';
import useYupValidationResolver from 'form/yup/reactHookFormResolver';
import { Box, Column, Grid } from 'lmc-ui-library';
import { Button, Heading, Text } from 'lmc-ui-library-rebrand';
import { ButtonsContainer, FormWrapper, Wrapper } from './ForgotPassword.styled';
import { FormInputWrapper, TextInput } from 'form/infrastructure/reactHookForm';
import { Link } from 'react-router-dom';
import Template from 'screens/BrokerPortal/screens/Registration/components/Template/Template';
import { login } from 'routes/routePaths';

import styles from './_ForgotPassword.module.scss';

type Form = UseFormReturn<ForgotFormData> & { formState: FormState<ForgotFormData> & { errors: any } }

const ForgotPassword: React.FC<ForgotFormProps> = ({ handleSubmitForm, isSubmitted, newUi }) => {
  const methods: Form = useForm<ForgotFormData>({
    mode: 'onSubmit',
    resolver: useYupValidationResolver(schemaForForgotPassword),
    defaultValues: {
      [FIELD.EMAIL]: null,
    },
  });

  const { handleSubmit } = methods;

  const onSubmit = handleSubmit((form: ForgotFormData) => handleSubmitForm(form));

  return (
    <FormWrapper>
      <Template>
        <Box>
          <Box.Content className={styles.setPasswordBox}>
            {!isSubmitted ? (
              <FormProvider<ForgotFormData> {...methods}>
                <Grid cols={12}>
                  <Column lg={7} md={10} sm={12} xs={12}>
                    <form onSubmit={onSubmit}>
                      <Heading weight="bold" mode="title">
                        Forgot Password
                      </Heading>

                      <Text weight="light">Enter your email address</Text>

                      <Text weight="light">
                        If your email address exists in our database we'll send you a link to reset your password.
                      </Text>

                      <FormInputWrapper
                        newUi={newUi}
                        title={FIELD_LABEL.EMAIL}
                        name={FIELD.EMAIL}
                        showMultipleErrors={true}>
                        <TextInput newUi={newUi} type="email" placeholder="example@livemoremortgages.com" />
                      </FormInputWrapper>

                      <ButtonsContainer>
                        <Button borderVariant="rectangle" mode="primary" mt={4} mb={5}>
                          Send
                        </Button>
                      </ButtonsContainer>
                    </form>
                  </Column>
                </Grid>
              </FormProvider>
            ) : (
              <Wrapper>
                <Heading weight="bold" mode="title">
                  A reset password link has been sent to your email address
                </Heading>
                <Text weight="light">
                  If you do not receive an email to reset your password please contact{' '}
                  <a href="mailto:sales@livemoremortgages.com">sales@livemoremortgages.com</a>
                </Text>

                <Link to={login}>
                  <Button borderVariant="rectangle" mode="ghost" mt={4} mb={5}>
                    Return to sign in page
                  </Button>
                </Link>
              </Wrapper>
            )}
          </Box.Content>
        </Box>
      </Template>
    </FormWrapper>
  );
};

export default ForgotPassword;
